import script from "./TooltipComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&setup=true&lang=js"

import "./TooltipComponent.vue?vue&type=style&index=0&id=578156de&lang=scss"

const __exports__ = script;

export default __exports__